/**
 * PropertyEditDialog - Dialog for editing a custom property
 * Similar to VariableEditDialog but for custom properties
 */

import type { Component, ChangeEvent } from 'react';
import { CustomProperty } from '../models/CustomProperty';
import Dialog from './Dialog';

// React is available globally from CDN
const React = (window as any).React;
const ReactComponent = React.Component;

// Forward declarations
declare const cheatFreezes: {
    customProperties: { [entityId: string]: { [propertyName: string]: boolean } };
};

interface PropertyEditDialogProps {
    entityId: string;
    property: CustomProperty;
    onSave: (value: string, frozen: boolean) => void;
    onCancel: () => void;
}

interface PropertyEditDialogState {
    value: string;
    frozen: boolean;
}

class PropertyEditDialog extends ReactComponent<PropertyEditDialogProps, PropertyEditDialogState> {
    constructor(props: PropertyEditDialogProps) {
        super(props);
        
        // Initialize cheatFreezes.customProperties if needed
        if (!cheatFreezes.customProperties) {
            (cheatFreezes as any).customProperties = {};
        }
        if (!cheatFreezes.customProperties[props.entityId]) {
            cheatFreezes.customProperties[props.entityId] = {};
        }
        
        this.state = {
            value: props.property.Value || '',
            frozen: !!(cheatFreezes.customProperties[props.entityId][props.property.Name])
        };
    }

    handleSave = (): void => {
        this.props.onSave(this.state.value, this.state.frozen);
    };

    handleCancel = (): void => {
        this.props.onCancel();
    };

    render(): any {
        const DialogComponent = (window as any).Dialog;
        if (!DialogComponent) return null;

        return React.createElement(DialogComponent, {
            title: `Edit Property: ${this.props.property.Name}`,
            onClose: this.handleCancel,
            actionButtons: React.createElement(React.Fragment, null,
                React.createElement('button', {
                    className: 'btn',
                    onClick: this.handleCancel
                }, 'Cancel'),
                React.createElement('button', {
                    className: 'btn',
                    onClick: this.handleSave
                }, 'Save')
            ),
            closeOnBackdropClick: false
        },
            React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '16px' } },
                React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '8px' } },
                    React.createElement('label', { style: { fontWeight: 'bold' } }, 'Value:'),
                    React.createElement('textarea', {
                        value: this.state.value,
                        onChange: (e: ChangeEvent<HTMLTextAreaElement>) => {
                            this.setState({ value: e.target.value });
                        },
                        rows: 4,
                        style: {
                            width: '100%',
                            padding: '8px',
                            fontFamily: 'var(--font-game-text)',
                            fontSize: '14px',
                            border: '1px solid rgba(0, 0, 0, 0.2)',
                            borderRadius: '4px',
                            resize: 'vertical'
                        }
                    })
                ),
                React.createElement('label', { style: { display: 'flex', alignItems: 'center', gap: '8px' } },
                    React.createElement('input', {
                        type: 'checkbox',
                        checked: this.state.frozen,
                        onChange: (e: ChangeEvent<HTMLInputElement>) => {
                            this.setState({ frozen: e.target.checked });
                        }
                    }),
                    React.createElement('span', null, 'Freeze property (prevent changes)')
                )
            )
        );
    }
}

(window as any).PropertyEditDialog = PropertyEditDialog;
export default PropertyEditDialog;
